import {
  IconAirfare,
  IconBills,
  IconCash,
  IconCatalog,
  IconEdit,
  IconExpense,
  IconOrder,
  IconRequest,
  IconVendor,
} from '@procurify/ui'

import { GlobalSearchListItemIconStyled } from './styles/GlobalSearchListItemIconStyled'
import {
  type GlobalSearchResultTypeEnum,
  GlobalSearchResultTypes,
} from '../../../../../../value-objects/enums'

interface IGlobalSearchListItemIconProps {
  type: GlobalSearchResultTypeEnum
}

export const GlobalSearchListItemIcon = ({
  type,
}: IGlobalSearchListItemIconProps) => {
  const icon = (() => {
    switch (type) {
      case GlobalSearchResultTypes.ORDER_REQUEST:
        return <IconRequest size={22} color='darkGrey' />
      case GlobalSearchResultTypes.EXPENSE_REQUEST:
        return <IconExpense size={22} color='darkGrey' />
      case GlobalSearchResultTypes.TRAVEL_REQUEST:
        return <IconAirfare size={22} color='darkGrey' />
      case GlobalSearchResultTypes.PURCHASE_ORDER:
        return <IconOrder size={22} color='darkGrey' />
      case GlobalSearchResultTypes.BILL:
        return <IconBills size={22} color='darkGrey' />
      case GlobalSearchResultTypes.PAYMENT:
        return <IconCash size={22} color='darkGrey' />
      case GlobalSearchResultTypes.VENDOR:
        return <IconVendor size={22} color='darkGrey' />
      case GlobalSearchResultTypes.CATALOG_ITEM:
        return <IconCatalog size={22} color='darkGrey' />
      case GlobalSearchResultTypes.CONTRACT:
        return <IconEdit size={22} color='darkGrey' />
      default:
        return null
    }
  })()

  if (!icon) {
    return null
  }

  return (
    <GlobalSearchListItemIconStyled aria-hidden='true'>
      {icon}
    </GlobalSearchListItemIconStyled>
  )
}
